// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as WebRouteRouteImport } from './routes/_web/route'
import { Route as InvitationsIdRouteImport } from './routes/invitations/$id'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppDashboardRouteImport } from './routes/app/dashboard'
import { Route as AppSpeechAgentRouteRouteImport } from './routes/app/speech-agent/route'
import { Route as AppAdminRouteRouteImport } from './routes/app/admin/route'
import { Route as WebIndexRouteImport } from './routes/_web/index'
import { Route as WebTosRouteImport } from './routes/_web/tos'
import { Route as WebSupportRouteImport } from './routes/_web/support'
import { Route as WebPrivacyPolicyRouteImport } from './routes/_web/privacy-policy'
import { Route as WebContactRouteImport } from './routes/_web/contact'
import { Route as AppSpeechAgentIndexRouteImport } from './routes/app/speech-agent/index'
import { Route as AppSpeechAgentAgentsRouteImport } from './routes/app/speech-agent/agents'
import { Route as AppAdminIndexRouteImport } from './routes/app/admin/index'
import { Route as AppAdminUsersRouteImport } from './routes/app/admin/users'
import { Route as AppAdminObservabilityRouteImport } from './routes/app/admin/observability'
import { Route as WebNewsroomIndexRouteImport } from './routes/_web/newsroom/index'
import { Route as WebNewsroomArticleIdRouteImport } from './routes/_web/newsroom/$articleId'
import { Route as AppProjectIdIndexRouteImport } from './routes/app/project/$id/index'
import { Route as AppOrganizationIdIndexRouteImport } from './routes/app/organization/$id/index'
import { Route as AppProjectIdSettingsRouteImport } from './routes/app/project/$id/settings'
import { Route as AppOrganizationIdSettingsRouteImport } from './routes/app/organization/$id/settings'
import { Route as AppOrganizationIdMembersRouteImport } from './routes/app/organization/$id/members'
import { Route as AppSpeechAgentHistorieIndexRouteImport } from './routes/app/speech-agent/historie.index'
import { Route as AppSpeechAgentHistorieIdRouteImport } from './routes/app/speech-agent/historie.$id'
import { Route as AppSpeechAgentAgentsIndexRouteImport } from './routes/app/speech-agent/agents.index'
import { Route as AppSpeechAgentAgentsNewRouteImport } from './routes/app/speech-agent/agents.new'
import { Route as AppSpeechAgentAgentsSlugRouteImport } from './routes/app/speech-agent/agents.$slug'

const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const AppRouteRoute = AppRouteRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const WebRouteRoute = WebRouteRouteImport.update({
            id: '/_web',getParentRoute: () => rootRouteImport
          })
const InvitationsIdRoute = InvitationsIdRouteImport.update({
            id: '/invitations/$id',path: '/invitations/$id',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRouteRoute
          })
const AppDashboardRoute = AppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AppRouteRoute
          })
const AppSpeechAgentRouteRoute = AppSpeechAgentRouteRouteImport.update({
            id: '/speech-agent',path: '/speech-agent',getParentRoute: () => AppRouteRoute
          })
const AppAdminRouteRoute = AppAdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AppRouteRoute
          })
const WebIndexRoute = WebIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WebRouteRoute
          })
const WebTosRoute = WebTosRouteImport.update({
            id: '/tos',path: '/tos',getParentRoute: () => WebRouteRoute
          })
const WebSupportRoute = WebSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => WebRouteRoute
          })
const WebPrivacyPolicyRoute = WebPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => WebRouteRoute
          })
const WebContactRoute = WebContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => WebRouteRoute
          })
const AppSpeechAgentIndexRoute = AppSpeechAgentIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppSpeechAgentRouteRoute
          })
const AppSpeechAgentAgentsRoute = AppSpeechAgentAgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => AppSpeechAgentRouteRoute
          })
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAdminRouteRoute
          })
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AppAdminRouteRoute
          })
const AppAdminObservabilityRoute = AppAdminObservabilityRouteImport.update({
            id: '/observability',path: '/observability',getParentRoute: () => AppAdminRouteRoute
          })
const WebNewsroomIndexRoute = WebNewsroomIndexRouteImport.update({
            id: '/newsroom/',path: '/newsroom/',getParentRoute: () => WebRouteRoute
          })
const WebNewsroomArticleIdRoute = WebNewsroomArticleIdRouteImport.update({
            id: '/newsroom/$articleId',path: '/newsroom/$articleId',getParentRoute: () => WebRouteRoute
          })
const AppProjectIdIndexRoute = AppProjectIdIndexRouteImport.update({
            id: '/project/$id/',path: '/project/$id/',getParentRoute: () => AppRouteRoute
          })
const AppOrganizationIdIndexRoute = AppOrganizationIdIndexRouteImport.update({
            id: '/organization/$id/',path: '/organization/$id/',getParentRoute: () => AppRouteRoute
          })
const AppProjectIdSettingsRoute = AppProjectIdSettingsRouteImport.update({
            id: '/project/$id/settings',path: '/project/$id/settings',getParentRoute: () => AppRouteRoute
          })
const AppOrganizationIdSettingsRoute = AppOrganizationIdSettingsRouteImport.update({
            id: '/organization/$id/settings',path: '/organization/$id/settings',getParentRoute: () => AppRouteRoute
          })
const AppOrganizationIdMembersRoute = AppOrganizationIdMembersRouteImport.update({
            id: '/organization/$id/members',path: '/organization/$id/members',getParentRoute: () => AppRouteRoute
          })
const AppSpeechAgentHistorieIndexRoute = AppSpeechAgentHistorieIndexRouteImport.update({
            id: '/historie/',path: '/historie/',getParentRoute: () => AppSpeechAgentRouteRoute
          })
const AppSpeechAgentHistorieIdRoute = AppSpeechAgentHistorieIdRouteImport.update({
            id: '/historie/$id',path: '/historie/$id',getParentRoute: () => AppSpeechAgentRouteRoute
          })
const AppSpeechAgentAgentsIndexRoute = AppSpeechAgentAgentsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppSpeechAgentAgentsRoute
          })
const AppSpeechAgentAgentsNewRoute = AppSpeechAgentAgentsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AppSpeechAgentAgentsRoute
          })
const AppSpeechAgentAgentsSlugRoute = AppSpeechAgentAgentsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => AppSpeechAgentAgentsRoute
          })





const WebRouteRouteChildren = {
  WebContactRoute: WebContactRoute,WebPrivacyPolicyRoute: WebPrivacyPolicyRoute,WebSupportRoute: WebSupportRoute,WebTosRoute: WebTosRoute,WebIndexRoute: WebIndexRoute,WebNewsroomArticleIdRoute: WebNewsroomArticleIdRoute,WebNewsroomIndexRoute: WebNewsroomIndexRoute
}

const WebRouteRouteWithChildren = WebRouteRoute._addFileChildren(WebRouteRouteChildren)




const AppAdminRouteRouteChildren = {
  AppAdminObservabilityRoute: AppAdminObservabilityRoute,AppAdminUsersRoute: AppAdminUsersRoute,AppAdminIndexRoute: AppAdminIndexRoute
}

const AppAdminRouteRouteWithChildren = AppAdminRouteRoute._addFileChildren(AppAdminRouteRouteChildren)




const AppSpeechAgentAgentsRouteChildren = {
  AppSpeechAgentAgentsSlugRoute: AppSpeechAgentAgentsSlugRoute,AppSpeechAgentAgentsNewRoute: AppSpeechAgentAgentsNewRoute,AppSpeechAgentAgentsIndexRoute: AppSpeechAgentAgentsIndexRoute
}

const AppSpeechAgentAgentsRouteWithChildren = AppSpeechAgentAgentsRoute._addFileChildren(AppSpeechAgentAgentsRouteChildren)



const AppSpeechAgentRouteRouteChildren = {
  AppSpeechAgentAgentsRoute: AppSpeechAgentAgentsRouteWithChildren,AppSpeechAgentIndexRoute: AppSpeechAgentIndexRoute,AppSpeechAgentHistorieIdRoute: AppSpeechAgentHistorieIdRoute,AppSpeechAgentHistorieIndexRoute: AppSpeechAgentHistorieIndexRoute
}

const AppSpeechAgentRouteRouteWithChildren = AppSpeechAgentRouteRoute._addFileChildren(AppSpeechAgentRouteRouteChildren)



const AppRouteRouteChildren = {
  AppAdminRouteRoute: AppAdminRouteRouteWithChildren,AppSpeechAgentRouteRoute: AppSpeechAgentRouteRouteWithChildren,AppDashboardRoute: AppDashboardRoute,AppIndexRoute: AppIndexRoute,AppOrganizationIdMembersRoute: AppOrganizationIdMembersRoute,AppOrganizationIdSettingsRoute: AppOrganizationIdSettingsRoute,AppProjectIdSettingsRoute: AppProjectIdSettingsRoute,AppOrganizationIdIndexRoute: AppOrganizationIdIndexRoute,AppProjectIdIndexRoute: AppProjectIdIndexRoute
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(AppRouteRouteChildren)

const rootRouteChildren = {
  WebRouteRoute: WebRouteRouteWithChildren,AppRouteRoute: AppRouteRouteWithChildren,SignInRoute: SignInRoute,SignUpRoute: SignUpRoute,InvitationsIdRoute: InvitationsIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)